import CityLogo from './CityLogo';

export default CityLogo;
